import {Select} from "antd";
import "./DeviceSelector.css";

const { Option } = Select;

const DeviceSelector = () => {
  return (
    <div className="selector-container">
      <Select
        defaultValue="all"
        className="selector-left"
        bordered={false}
      >
        <Option value="all">All devices</Option>
        <Option value="device1">Device 1</Option>
      </Select>

      <Select
        defaultValue="hero"
        className="selector-right"
        bordered={false}
      >
        <Option value="hero">Hero Pharmacy Services</Option>
        <Option value="other">Other</Option>
      </Select>
    </div>
  );
};

export default DeviceSelector;
